import {
  Component,
  ElementRef,
  OnInit,
  ViewChild,
  OnChanges,
  Renderer
} from "@angular/core";
import { Observable } from "rxjs/Observable";
import { Subject } from "rxjs/Subject";
import "rxjs/add/observable/of";
import "rxjs/add/operator/map";
import "rxjs/add/observable/of";
import "rxjs/add/operator/catch";
import "rxjs/add/operator/debounceTime";
import "rxjs/add/operator/distinctUntilChanged";
import "rxjs/add/operator/do";
import "rxjs/add/operator/switchMap";

import { Router, ActivatedRoute, Params } from "@angular/router";

import { SearchService } from "./services/search.service";
import { VisorService } from "./services/visor.service";
import { UtilsService } from "./services/utils.service";
import { UsercontrolService } from "./services/usercontrol.service";

declare var jQuery: any;

@Component({
  moduleId: module.id,
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  providers: [SearchService, VisorService, UtilsService, UsercontrolService]
})
export class AppComponent implements OnInit {
  @ViewChild("sellaw") selLawElement: ElementRef;
  @ViewChild("txtlaw") txtLawElement: ElementRef;
  @ViewChild("selart") selArtElement: ElementRef;
  @ViewChild("txtart") txtArtElement: ElementRef;
  @ViewChild("btnart") btnArtElement: ElementRef;

  constructor(
    public _element: ElementRef,
    private _searchService: SearchService,
    private _visorService: VisorService,
    private _utilsService: UtilsService,
    private _userControlService: UsercontrolService,
    private router: Router,
    private route: ActivatedRoute,
    private renderer: Renderer
  ) {}

  // define properties
  subjectSearchLaw: Subject<string> = new Subject<string>();
  subjectSearchArt: Subject<string> = new Subject<string>();
  title = "Buscador de Articulos";
  listLaw: Array<{ text: string; value: string }>;
  listArtSource: Array<{ text: string; value: string }> = [];
  listArtShow: Array<{ text: string; value: string }> = [];
  showListLawOption = false;
  showListArtOption = false;
  searching = false;
  valueLaw = "";
  valueArt = "";
  searchFailed = false;
  selectedLaw: string = "";
  selectedArt: string = "";
  inputFocused: boolean = false;
  searchingText = "Buscando en Normas";
  keyArrowDownWasPressed = false;
  documento: string = "";

  ngOnInit() {

    this._visorService.wasCalled().subscribe(t => {
      //setTimeout(() => {
      this.showListArtOption = false;
      this.showListLawOption = false;
      if (!this.listLaw) {
        this.listLaw = [];
        this.listLaw.push({ text: t.Nombre, value: t.Codigo });
        this.selectedLaw = t.Codigo;
        this.handleEnterLaw(t.Codigo, t.Articulo);
        this.documento = t.Nombre;
      } else {
        this.selectedArt = t.Articulo;
        let index = this.listArtShow.findIndex(x => {
          return x.value == t.Articulo;
        });
        this.valueArt = index !== -1 ? this.listArtShow[index].text : "";
      }
      //}, 1200);
    });

    this.searchLaw()
      .debounceTime(600)
      .subscribe(t => {
        this.onSearchLaw(t);
      });

    this.searchArt()
      .debounceTime(300)
      .subscribe(t => {
        this.onSearchArt(t);
      });

    /*this._userControlService.getUserControl('FindFinishCountdown').subscribe(u => {
        jQuery("#FindFinishCountdownControl").html(u);
        this.renderer.listen(this._element.nativeElement.querySelector('#FindFinishCountdownControl'), "click", (e) => {
          this.closeDialog();
        });
      });*/

    //this._visorService.checkSearchCount()
  }

  public searchLaw(): Observable<string> {
    return this.subjectSearchLaw.asObservable();
  }

  public searchArt(): Observable<string> {
    return this.subjectSearchArt.asObservable();
  }

  // Methods
  onSearchLaw(value: string) {
    this.searching = true;
    this.searchingText = "Buscando norma...";
    this._searchService
      .search(value)
      .debounceTime(800)
      .distinctUntilChanged()
      .subscribe(res => {
        this.listLaw = [];
        this.searching = false;
        res.forEach(t => {
          this.listLaw.push(t);
        });
        this.showListLawOption = true;
        setTimeout(() => {
          this.selLawElement.nativeElement.size = this.listLaw.length + 1;
          this.selectedLaw = this.listLaw[0].value;
        }, 300);
      });
  }

  onSearchArt(value: String) {
    if (!value) {
      let arts = this.listArtSource;
      this.listArtShow = arts;
      this.showListArtOption = true;
      setTimeout(() => {
        if (this.selArtElement) {
          this.selArtElement.nativeElement.size = this.listArtShow.length + 1;
        }
      }, 1500);

      return;
    }

    let words = value.split(" ");
    let arts = this.listArtSource;
    this.listArtShow = arts.filter(t =>
      this._utilsService.contentWords(t.text, words)
    );
    this.showListArtOption = true;
    if (this.selArtElement) {
      this.selArtElement.nativeElement.size = this.listArtShow.length + 1;
    }
  }

  handleLawChange(value) {}

  listLawNotEmpty() {
    if (this.listLaw) {
      return this.listLaw.length != 0;
    } else {
      return false;
    }
  }

  handleSelectedLaw(value: String) {
    if (!value) {
      return;
    }
    this.valueLaw = this.listLaw.find(t => t.value == this.selectedLaw).text;
  }

  handleEnterLaw(value: string, articulo: string) {
    this.showListLawOption = false;
    this.txtLawElement.nativeElement.focus();
    this.txtLawElement.nativeElement.select();

    if (!articulo && typeof jQuery === "function")
      jQuery("body").mask("Buscando Articulos...");

    let remove:any = require("remove-accents");
    if (!value) {
      let found = this.listLaw.find(
        t => remove(t.text).toLowerCase().indexOf(remove(this.valueLaw).toLowerCase()) != -1
      );
      if (found) {
        this.valueLaw = found.text;
        this.selectedLaw = found.value;
      } else {
        return;
      }
    }

    this._visorService
      .searchArticles("", this.selectedLaw)
      .debounceTime(1000)
      .subscribe(res => {
        this.listArtSource = [];
        this.listArtShow = [];
        res.forEach(t => {
          t.text = t.text.replace("&gt;", ">").replace("&lt;", "<");
          this.listArtSource.push(t);
        });

        let resArr = [];
        this.listArtSource.filter((x, i, a) => {
          if (resArr.indexOf(x.value) === -1) {
            resArr.push(x.value);
            this.listArtShow.push(x);
          }
        });

        this.listArtSource = this.listArtShow.slice(0);

        setTimeout(() => {
          if (!articulo) this.txtArtElement.nativeElement.focus();
          this.selArtElement.nativeElement.size = Math.min(
            this.listArtShow.length,
            10
          );
          if (this.selectedArt)
            this.selectedArt = this.listArtShow.length
              ? this.listArtShow[0].value
              : null;
          this.handleSelectedLaw(value);
          if (!articulo && typeof jQuery === "function")
            jQuery("body").unmask();
          if (articulo) {
            this.selectedArt = articulo;
            this.handleSelectedArt(articulo);
          }
        }, 500);
      });
  }

  handleKeydownLaw($event) {
    if ($event.key == "Enter") {
      this.keyArrowDownWasPressed = true;
      if (this.selLawElement) {
        this.selLawElement.nativeElement.focus();
        this.valueLaw = this.listLaw.find(
          t => t.value == this.selectedLaw
        ).text;
      }
    }

    if ($event.key == "ArrowDown") {
      this.keyArrowDownWasPressed = true;
      if (this.selLawElement) {
        this.selLawElement.nativeElement.focus();
        this.valueLaw = this.listLaw.find(
          t => t.value == this.selectedLaw
        ).text;
      }
    }
  }

  onChangeLawValue($event) {
    let value = this.valueLaw;
    if (value == null || value == "") {
      this.showListLawOption = false;
      this.showListArtOption = false;
      this.listLaw = [];
      this.listArtShow = [];
      this.valueArt = null;
      this.selectedArt = null;
    } else {
      this.valueArt = null;
      this.selectedArt = null;
      this.subjectSearchLaw.next(this.valueLaw);
    }
  }

  handleSelectedArt(value: String) {
    if (value.length == 0) {
      return;
    }
    this.valueArt = this.listArtShow.find(
      t => t.value == this.selectedArt
    ).text;
  }

  handleEnterArt(value) {
    this.showListArtOption = false;
    setTimeout(() => {
      this.btnArtElement.nativeElement.focus();
      this.handleSelectedArt(value);
      this.onClickFindArticle();
    }, 200);
  }

  handleKeydownArt($event) {
    if ($event.key == "ArrowDown") {
      this.keyArrowDownWasPressed = true;
      if (this.selArtElement) {
        this.selArtElement.nativeElement.focus();
        this.selectedArt = this.listArtShow[0].value;
      }
    }
  }

  onClickFindArticle() {
    let law = this.selectedLaw;
    this.router.navigateByUrl(law + "/articulo/" + this.selectedArt);
    this.documento = this.valueLaw;
  }

  onChangeArtValue($event) {
    this.subjectSearchArt.next(this.valueArt);
  }

  onBlurInputLaw() {
    setTimeout(() => {
      if (!this.keyArrowDownWasPressed) this.showListLawOption = false;

      this.keyArrowDownWasPressed = false;
    }, 200);
  }

  onFocusInputLaw() {}

  onBlurInputArt() {
    setTimeout(() => {
      if (!this.keyArrowDownWasPressed) this.showListArtOption = false;

      this.keyArrowDownWasPressed = false;
    }, 200);
  }

  onFocusInputArt() {
    if (this.listArtShow.length) {
      this.showListArtOption = true;
      this.selArtElement.nativeElement.size = Math.min(
        this.listArtShow.length,
        10
      );
    }
  }

  onFocusSelArt() {
    this.keyArrowDownWasPressed = true;
  }

  closeDialog() {
    if (typeof jQuery === "function")
      jQuery("#findFinishCountdownDialog").modal("hide");
    this.resetData();
    this.router.navigate([""]);
  }

  resetData() {
    this.listLaw = [];
    this.listArtSource = [];
    this.listArtShow = [];
    this.showListLawOption = false;
    this.showListArtOption = false;
    this.searching = false;
    this.valueLaw = "";
    this.valueArt = "";
    this.searchFailed = false;
    this.selectedLaw = "";
    this.selectedArt = "";
    this.inputFocused = false;
    this.keyArrowDownWasPressed = false;
    this.documento = "";
  }
}



// WEBPACK FOOTER //
// C:/Workspaces/Redjurista/MAIN/Source/Asterysco.AJ.Lawtheque/GUI/Angular Components/findarticles/src/app/app.component.ts